// `TripSuggestedPickupTime` is one spec schema whose fields are split by
// direction: the request carries the trip details, the response carries only
// `pickup_at`. hey-api emits a single type with all of them required, so name
// each direction's half here rather than widening request bodies and
// response fixtures to satisfy the other side's fields.
import type {
  TripSuggestedPickupTime,
  TripsSuggestedPickupAtCreateApiArg,
} from '@bambi/api-client/schemas';

export type SuggestedPickupTimeRequest = Omit<
  TripSuggestedPickupTime,
  'pickup_at'
>;

export type SuggestedPickupTimeResponse = Pick<
  TripSuggestedPickupTime,
  'pickup_at'
>;

/**
 * Build the mutation argument from the fields the endpoint reads. The cast is
 * the one place the merged type is reconciled; sending `pickup_at` instead
 * would change the request body.
 */
export const suggestedPickupTimeArg = (
  request: SuggestedPickupTimeRequest
): TripsSuggestedPickupAtCreateApiArg => ({
  tripSuggestedPickupTime: request as TripSuggestedPickupTime,
});
